module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0032.jpg?v=7c17c46b";